<template>
	<div class="game-list container-fluid text-center">
		<nav class="list-unstyled text-uppercase">
			<button
				@click="$emit('openTutorial')"
				type="button"
				class="btn btn-pink text-uppercase"
			>
				{{ 'demo.tutorial.title' | translate }}
			</button>
			<router-link to="/demo/addition" class="btn btn-pink">{{
				'Speedy numbers' | translate
			}}</router-link>
			<router-link to="/demo/columns" class="btn btn-pink">{{
				'games.columns.name' | translate
			}}</router-link>
			<router-link to="/demo/abacus-game" class="btn btn-pink">{{
				'Abacus' | translate
			}}</router-link>
			<router-link to="/" class="btn btn-pink">{{
				'Back' | translate
			}}</router-link>
		</nav>
	</div>
</template>

<script>
export default {
	name: 'demo-game-list',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-pink {
	display: block;
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	line-height: 2;
	margin: 0px auto 20px;
	width: 260px;
	cursor: pointer;
}

.btn-pink:hover {
	background-color: #e85183;
}
</style>
